
// Packages
import axios from "axios";

const sendWritingScoreReportEmail = (writing_passed, exam_component_name, test_taker_id) => {
    const token = localStorage.getItem("access_token");

    //axios call to Django view
    axios
    .post(`${process.env.REACT_APP_API_BASE_URL}api/send-writing-score-report-email/`, {
        writing_score: writing_passed === 'true' ? 'PASS' : writing_passed === 'false' ? 'FAIL' : 'No Grade',
        exam_component_name: exam_component_name,
        test_taker_id: test_taker_id,
    }, {
        headers : {
            Authorization: `Bearer ${token}`
        }
    })
    .then((response) => {
        if (response.status === 200) {
            console.log("Writing score report sent successfully:", response.data);
        }
    })
    .catch((error) => {
        console.log(error)
    });

};

export default sendWritingScoreReportEmail;